var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modalContents__object01",
      attrs: { "data-modalContents": "mainMenu" }
    },
    [
      _c("div", { staticClass: "modalContents__object01__menu" }, [
        _c("div", { staticClass: "modalContents__object01__menu__btn" }, [
          _c(
            "a",
            {
              staticClass: "globalModal--btn",
              attrs: {
                href: "javascript:void(0)",
                "data-modal": "mainMenuClose",
                title: "close"
              },
              on: { click: _vm.hideModal }
            },
            [_vm._m(0)]
          )
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "modalContents__object01__menu__gate" }, [
          _c("ul", { staticClass: "clearfix" }, [
            _c("li", [
              !_vm.isLogged
                ? _c(
                    "a",
                    {
                      staticClass: "globalModal--btn",
                      attrs: { href: "javascript:void(0)", title: "ログイン" },
                      on: { click: _vm.showModalLogin }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-chevron-circle-right",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("Login")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLogged
                ? _c(
                    "a",
                    {
                      staticClass:
                        "modalContents__object01__menu__gate--logout",
                      attrs: { href: "/auth/logout", title: "ログアウト" }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-chevron-circle-right",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("Logout")
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", [
              !_vm.isLogged
                ? _c(
                    "a",
                    {
                      staticClass: "globalModal--btn",
                      attrs: {
                        "data-modal": "signup",
                        href: "javascript:void(0)",
                        title: "新規登録"
                      },
                      on: { click: _vm.showModalMain }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-chevron-circle-right",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("Sign Up")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLogged
                ? _c(
                    "a",
                    {
                      staticClass:
                        "modalContents__object01__menu__gate--mypage globalModal--btn",
                      attrs: {
                        "data-modal": "mypage",
                        href: "javascript:void(0)",
                        title: "マイページ"
                      },
                      on: { click: _vm.showModalMypageTop }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-chevron-circle-right",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("My Page")
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3)
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack fa-lg" }, [
      _c("i", {
        staticClass: "fa fa-circle-thin fa-stack-2x fa-inverse",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fa fa-times fa-stack-1x fa-inverse",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("a", { attrs: { href: "/", title: "ニューズ・オプエド" } }, [
        _c("img", {
          attrs: {
            src: "/images/common/logo01.png",
            width: "152",
            height: "64",
            alt: "ニューズ・オプエド 英字ロゴ"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "hidden-xs-down",
          attrs: {
            src: "/images/common/logo03.png",
            width: "182",
            height: "64",
            alt: "ニューズ・オプエド 和文ロゴ"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modalContents__object01__menu__list" }, [
      _c("ul", [
        _c("li", [
          _c(
            "a",
            { attrs: { href: "/", title: "ニューズ・オプエドトップページ" } },
            [_vm._v("TOP")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "/about.html", title: "ニューズ・オプエドとは" } },
            [_vm._v("ABOUT")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/video", title: "動画一覧" } }, [
            _vm._v("VIDEOS")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "/performer", title: "コメンテーター一覧" } },
            [_vm._v("GUESTS")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/news", title: "ニュース一覧" } }, [
            _vm._v("NEWS")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/sports", title: "スポーツ一覧" } }, [
            _vm._v("SPORTS")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modalContents__object01__menu__sns" }, [
      _c("ul", { staticClass: "d-flex justify-content-start" }, [
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://twitter.com/news_oped",
                target: "_blank",
                title: "ツイッター"
              }
            },
            [
              _c("span", { staticClass: "fa-stack fa-lg" }, [
                _c("i", {
                  staticClass: "fa fa-circle fa-stack-2x fa-inverse",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c(
                  "i",
                  {
                    staticClass: "fa fa-twitter fa-stack-1x",
                    attrs: { "aria-hidden": "true" }
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("ツイッター")
                    ])
                  ]
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.facebook.com/news.oped/",
                target: "_blank",
                title: "フェイスブック"
              }
            },
            [
              _c("span", { staticClass: "fa-stack fa-lg" }, [
                _c("i", {
                  staticClass: "fa fa-circle fa-stack-2x fa-inverse",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c(
                  "i",
                  {
                    staticClass: "fa fa-facebook fa-stack-1x",
                    attrs: { "aria-hidden": "true" }
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("フェイスブック")
                    ])
                  ]
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://www.youtube.com/channel/UCGNduTqLENPjULlaSWGCNIA",
                target: "_blank",
                title: "ユーチューブ"
              }
            },
            [
              _c("span", { staticClass: "fa-stack fa-lg" }, [
                _c("i", {
                  staticClass: "fa fa-circle fa-stack-2x fa-inverse",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c(
                  "i",
                  {
                    staticClass: "fa fa-youtube-play fa-stack-1x",
                    attrs: { "aria-hidden": "true" }
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("ユーチューブ")
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e276626", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e276626","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/main_menu.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1e276626","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/main_menu.vue
// module chunks = 0